import TablePagination from '@mui/material/TablePagination'

import { Actions } from './Actions'
import css from './CustomPagination.module.scss'

type Props = Omit<Parameters<typeof TablePagination>[0], 'ActionsComponent'>

export const PaginationWrapper = (props: Props) => (
	<TablePagination
		ActionsComponent={Actions}
		className={css.wrapper}
		showFirstButton
		showLastButton
		{...props}
	/>
)
